import { EmailCaptureConfig, VideoOption } from '@/types/vsleads/emailCaptureTypes';

export const getDefaultEmailCaptureConfig = (): EmailCaptureConfig => ({
  videoId: '',
  isActive: true,

  orientation: 'horizontal',
  position: 'center',
  dimensions: {
    width: 420,
    padding: 16,
  },
  offsets: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },

  fields: [
    {
      id: 'nome',
      type: 'name',
      label: 'Nome',
      placeholder: 'Digite seu nome',
      required: true,
      active: true,
    },
    {
      id: 'email',
      type: 'email',
      label: 'E-mail',
      placeholder: 'Digite seu e-mail',
      required: true,
      active: true,
    },
    {
      id: 'whatsapp',
      type: 'phone',
      label: 'WhatsApp',
      placeholder: 'Digite seu WhatsApp',
      required: true,
      active: true,
    },
  ],
  fieldLabelStyle: 'placeholder',

  texts: {
    headline: 'Libere o acesso ao vídeo',
    footer: '',
    buttonText: 'Play',
    skipEnabled: false,
  },

  style: {
    container: {
      background: { value: '#000000', opacity: 0.95 },
      border: { color: '#E4E8F0', width: 1 },
      radius: 16,
      shadow: 2,
      blur: 0,
    },
    fields: {
      background: '#FFFFFF',
      border: '#D1D5DB',
      placeholder: '#9CA3AF',
      radius: 8,
      focusShadow: 1,
    },
    button: {
      normal: '#3072FF',
      text: '#FFFFFF',
      hover: '#2563EB',
      pressed: '#1D4ED8',
      radius: 8,
      shadow: 1,
    },
    text: {
      title: '#FFFFFF',
      footer: '#D1D5DB',
    },
    overlay: {
      darkness: 0,
      blur: 0,
    },
  },

  timer: {
    enabled: false,
    moment: '00:15',
    pauseOnOpen: true,
    pauseAfterSubmit: false,
    blockClose: false,
  },
});

export const mockVideos: VideoOption[] = [
  { id: '1', title: 'Webinar de Lançamento', thumbnail: 'https://placehold.co/160x90/6366f1/white' },
  { id: '2', title: 'VSL Principal', thumbnail: 'https://placehold.co/160x90/8b5cf6/white' },
  { id: '3', title: 'Funil Dinâmico Teste', thumbnail: 'https://placehold.co/160x90/ec4899/white' },
];
